import { render, staticRenderFns } from "./Clinic.vue?vue&type=template&id=aeaf65e4&scoped=true"
import script from "./Clinic.vue?vue&type=script&lang=js"
export * from "./Clinic.vue?vue&type=script&lang=js"
import style0 from "./Clinic.vue?vue&type=style&index=0&id=aeaf65e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeaf65e4",
  null
  
)

export default component.exports